<template>
  <div class="wrap">
    <!-- 选择上传人员时的弹窗 -->
    <div class="dialog_uploadRc" v-if="uploadRcWin">
      <el-dialog
        :custom-class="'animate__animated animate__fadeIn'"
        top="20vh"
        :modal="false"
        title="选择需要上传的人员"
        :visible.sync="uploadRcWin"
        center
        :before-close="fnCloseUploadRc"
      >
        <div class="search_name">
          <div class="line_input">
            <div class="input_title">人员姓名</div>
            <input type="text" class="input_box" placeholder="请输入人员姓名" v-model="searchName" @input="fnSearchName" />
          </div>
          <!-- <div class="search-btn" @click="fnSearchName"><span>搜索</span></div> -->
        </div>
        <div class="line_item">
          <span>总人员数: {{ uploadRcListAll.length }}人;</span>
          <span>新增人数：{{ addCount }}人;</span>
          <span>删除人数：{{ deleteCount }}人;</span>
          <span>编辑人数：{{ editCount }}人。</span>
          <span style="color: #FFBA00;position: absolute;right: 30px;">如需搜索，请使用Ctrl+F实现！</span>
        </div>
        <div class="cont_list">
          <div class="list_title">
            <div class="title_item"><div class="select" @click="fnSelectPerAll()" :class="selectPerAll ? 'active' : ''"></div></div>
            <div class="title_item">姓名</div>
            <div class="title_item">身份证照</div>
            <div class="title_item">性别</div>
            <div class="title_item">身份证号</div>
            <div class="title_item">电话号码</div>
            <div class="title_item">班组</div>
            <div class="title_item">工种</div>
            <div class="title_item">融创单位</div>
            <div class="title_item">融创工种</div>
            <div class="title_item">状态</div>
          </div>
          <div class="list_boxes">
            <div class="list_box">
              <div v-if="uploadRcList">
                <div class="box_line" v-for="(item, index) in uploadRcList" :key="index">
                  <div class="list_item"><div class="select" @click="fnHandleCheckedPerChange(index)" :class="item.selected ? 'active' : ''"></div></div>
                  <div class="list_item">{{ item.name }}</div>
                  <div class="list_item"><img :src="item.photo || 'http://cqzgzl.oss-cn-chengdu.aliyuncs.com/image/40fd31b9434de0d6cc965f1c2b475368.jpg'" /></div>
                  <div class="list_item">{{ item.sex == 1 ? '男' : '女' }}</div>
                  <div class="list_item"><input type="text" class="input_box" placeholder="请输入身份证号" v-model="item.extend.card_id" /></div>
                  <div class="list_item"><input type="text" class="input_box" placeholder="请输入电话号码" v-model="item.phone" /></div>
                  <div class="list_item" :title="fnTeamFormat(item.department)">
                    <span>{{ fnTeamFormat(item.department) }}</span>
                  </div>
                  <div class="list_item" :title="fnTeamFormat(item.position)">
                    <span>{{ fnTeamFormat(item.position) }}</span>
                  </div>
                  <div class="list_item">
                    <el-select size="small" class="select_box" v-model="item.extend.companyId" :popper-append-to-body="false" filterable placeholder="请选择" style="border-radius: 0;" >
                      <el-option label="请选择" value></el-option>
                      <el-option :label="item.name" :value="item.id" v-for="(item, index) in companys" :key="index"></el-option>
                    </el-select>
                  </div>
                  <div class="list_item">
                    <el-select size="small" class="select_box" @change=" e => { fnChangeProfessionsName(e, index); }"
                      v-model="item.extend.professionId"
                      :popper-append-to-body="false"
                      filterable
                      placeholder="请选择"
                      style="border-radius: 0;"
                    >
                      <el-option label="请选择" value></el-option>
                      <el-option :label="item.name" :value="item.id" v-for="(item, index) in professions" :key="index"></el-option>
                    </el-select>
                  </div>
                  <div class="list_item">{{ fnGetStatus(item.uploadStatus) }}</div>
                </div>
              </div>
              <div class="line_item center" v-if="uploadRcList.length < uploadRcListAll.length">---- 请点击加载更多按钮 ----</div>
              <div class="line_item center" v-else>---- 没有更多了 ----</div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer" align="center">
          <div class="btn_line">
            <div class="search-btn" v-if="uploadRcList.length < uploadRcListAll.length && !searchName" @click="fnLoadMore"><span>加载更多</span></div>
            <div class="search-btn red" @click="fnCloseUploadRc"><span>取消</span></div>
            <div class="search-btn" @click="fnIsUploadPersonToRc"><span>上传</span></div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 上传人员时进度条 -->
    <div class="progress" v-if="showProgress" style="z-index: 2500;">
      <div class="progress-box">
        <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage"></el-progress>
        <span>{{ progressText }}</span>
      </div>
    </div>
    <!-- 人员上传失败信息弹窗 -->
    <div class="dialog_uploadError" style="z-index: 2500;" v-if="showErrorInfoRc">
      <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="24vh" :modal="false" title="人员上传失败" :visible.sync="showErrorInfoRc" center>
        <div class="cont_list">
          <div class="list_title">
            <div class="title_item">姓名</div>
            <div class="title_item">身份证照</div>
            <div class="title_item">失败原因</div>
          </div>
          <div class="list_boxes">
            <div class="list_box">
              <div v-if="errorInfoRcList">
                <div class="box_line" v-for="(item, index) in errorInfoRcList" :key="index">
                  <div class="list_item">{{ item.info.name }}</div>
                  <div class="list_item"><img :src="item.info.photo || 'http://cqzgzl.oss-cn-chengdu.aliyuncs.com/image/40fd31b9434de0d6cc965f1c2b475368.jpg'" /></div>
                  <div class="list_item" :title="item.result">
                    <span>{{ item.result }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="btn_line">
            <div class="search-btn red" @click="showErrorInfoRc = false"><span>关闭</span></div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 人员是否上传弹窗 -->
    <div class="dialog_isUpload" v-if="isUploadShow">
      <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="提示信息" :visible.sync="isUploadShow" center>
        <div>上传过程中请勿关闭页面</div>
        <div slot="footer" class="dialog-footer">
          <div class="btn_line">
            <div class="search-btn red" @click="isUploadShow = false"><span>取消</span></div>
            <div class="search-btn" @click="fnUploadPersonToRc"><span>确定</span></div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import APP from '@/utils/base';
import { fnRequestPlatform } from '@/utils/upload';
import * as imageConversion from 'image-conversion';
export default {
  data() {
    return {
      uploadRcWin: false, // 弹窗
      selectPerAll: false, // 全选
      uploadRcList: [], // 需要上传的人员列表
      uploadRcListAll: [], // 需要上传的所有人员列表
      companys: [], // 融创单位
      professions: [], // 融创工种
      professionsAll: [], // 融创工种
      addCount: 0, // 添加人员数
      deleteCount: 0, // 删除人员数
      editCount: 0, // 编辑人员数
      selectedUploadRc: [], // 选择上传的人员
      showProgress: false, // 上传进度条
      percentage: 0, // 进度条百分比
      progressText: '上传中…', // 进度条文字显示
      showErrorInfoRc: false, // 人员上传失败弹窗
      errorInfoRcList: [], // 上传失败的人员列表
      isUploadShow: false, // 是否上传
      searchName: ''
    };
  },
  created() {
    this.fnUploadPersonToRC();
    setTimeout(() => {
      this.uploadRcWin = true;
    }, 300);
  },
  methods: {
    // 切换上传状态
    fnGetStatus(_status) {
      switch (parseInt(_status)) {
        case 0:
          return '添加';
        case 1:
          return '删除';
        case 2:
          return '编辑';
        default:
          return '添加';
      }
    },
    fnSearchName() {
      if (this.searchName != '') {
        let list = JSON.parse(JSON.stringify(this.uploadRcListAll));
        let _arr = [];
        for (let i in list) {
          if (list[i].name.includes(this.searchName)) {
            list[i].selected = false;
            list[i].extend.professionId ? list[i].extend.professionId : (list[i].extend.professionId = '');
            list[i].extend.companyId ? list[i].extend.companyId : (list[i].extend.companyId = '');
            list[i].extend.card_id ? list[i].extend.card_id : (list[i].extend.card_id = list[i].idcard);
            let _photoUrl = 'https:' + (list[i].photo ? list[i].photo.split(':')[1] : list[i].photo);
            // APP.fnDealImage(_photoUrl, { quality: 0.5 }, res => { list[i]['_photo'] = res.split(',')[1]; });
            APP.fnDealPic(_photoUrl, {size: 45, scale: 0.5}, res=>{ list[i]['_photo'] = res ? res : null })
            _arr.push(list[i]);
          }
        }
        this.uploadRcList = _arr;
      } else {
        this.uploadRcList = [];
        this.fnLoadMore();
      }
    },
    // select professions -> name
    fnChangeProfessionsName(e, index) {
      for (let i in this.professions) {
        if (this.professions[i].id == e) {
          this.uploadRcList[index].professionName = this.professions[i].name;
          this.uploadRcList[index].companyName = this.professionsAll[i].name.split('/')[1];
        }
      }
    },
    // 关闭上传融创弹出
    fnCloseUploadRc() {
      this.$parent.fnCloseUploadRc();
    },
    // 班组格式化 去除 #
    fnTeamFormat(_name) {
      return APP.fnTeamFormat(_name);
    },
    // 全选
    fnSelectPerAll() {
      this.selectPerAll = !this.selectPerAll;
      if (this.selectPerAll) {
        for (let i = 0; i < this.uploadRcList.length; i++) {
          this.uploadRcList[i].selected = true;
        }
        this.selectedUploadRc = this.uploadRcList;
      } else {
        for (let i = 0; i < this.uploadRcList.length; i++) {
          this.uploadRcList[i].selected = false;
        }
        this.selectedUploadRc = [];
      }
    },
    // 单个选择
    fnHandleCheckedPerChange(_index) {
      for (let i = 0; i < this.uploadRcList.length; i++) {
        if (i == _index) {
          this.uploadRcList[i].selected = !this.uploadRcList[i].selected;
        }
      }
      let _arr = [];
      for (let j = 0; j < this.uploadRcList.length; j++) {
        if (this.uploadRcList[j].selected) {
          _arr.push(this.uploadRcList[j]);
        }
      }
      if (_arr.length == this.uploadRcList.length) {
        this.selectPerAll = true;
      } else {
        this.selectPerAll = false;
      }
      this.selectedUploadRc = _arr;
    },
    // 获取上传融创人员
    fnUploadPersonToRC() {
      fnRequestPlatform(
        {
          url: '/Rc/getProjectPersonnel',
          method: 'GET'
        },
        res => {
          let _companys = res.data.companys;
          this.companys = _companys;
          let _personnel = res.data.personnel;
          this.professionsAll = JSON.parse(JSON.stringify(res.data.professions));
          let _professions = res.data.professions;
          for (let i in _professions) {
            let _index = _professions[i].name.lastIndexOf('/');
            _professions[i].name = _professions[i].name.substring(_index + 1);
          }
          this.professions = _professions;
          for (let i in _personnel) {
            switch (_personnel[i].uploadStatus) {
              case 0:
                this.addCount++;
                break;
              case 1:
                this.deleteCount++;
                break;
              case 2:
                this.editCount++;
                break;
              default:
                this.addCount++;
            }
          }
          this.uploadRcListAll = _personnel;
          this.fnLoadMore();
        }
      );
    },
    // 加载更多
    fnLoadMore() {
      let _len = this.uploadRcList.length;
      let _arr = JSON.parse(JSON.stringify(this.uploadRcListAll));
      let _personnel = [];
      _len == 0 ? 0 : _len - 1;
      if (_arr.length - _len > 10) {
        _personnel = _arr.splice(_len, 10);
      } else {
        _personnel = _arr.splice(_len);
      }
      for (let i in _personnel) {
        _personnel[i].selected = false;
        _personnel[i].extend.professionId ? _personnel[i].extend.professionId : (_personnel[i].extend.professionId = '');
        _personnel[i].extend.companyId ? _personnel[i].extend.companyId : (_personnel[i].extend.companyId = '');
        _personnel[i].extend.card_id ? _personnel[i].extend.card_id : (_personnel[i].extend.card_id = _personnel[i].idcard);
        let _photoUrl = 'https:' + (_personnel[i].photo ? _personnel[i].photo.split(':')[1] : _personnel[i].photo);
        // APP.fnDealImage(_photoUrl, { quality: 0.5 }, res => { _personnel[i]['_photo'] = res.split(',')[1]; });
        APP.fnDealPic(_photoUrl, {size: 45, scale: 0.5}, res=>{ _personnel[i]['_photo'] = res ? res : null })
      }
      this.uploadRcList = this.uploadRcList.concat(_personnel);
    },
    // 打开是否上传弹窗
    fnIsUploadPersonToRc() {
      let _that = this;
      let _selected = _that.selectedUploadRc;
      if (!_selected.length) {
        return _that.$message.warning('请选择需要上传的人员');
      }
      _that.isUploadShow = true;
    },
    // 上传人员至融创
    fnUploadPersonToRc() {
      let _that = this;
      let _selected = JSON.parse(JSON.stringify(_that.selectedUploadRc));
      let _percentage = 0;
      _that.percentage = 0;
      _that.progressText = '上传中…';
      _that.showProgress = true;
      let _start = 0;
      let _num = _selected.length; // 每次上传的数据条数
      let _count = _selected.length; // 总条数
      let _tenArr = [];
      let _tenArrIndex = 0;
      let _uploadResult = [];
      let _tage = Number(APP.fnTwoFloat(100 / _count));
      let _result = new Array(Math.ceil(_count / _num));
      // 进行循环
      while (_start < _count) {
        _result[_tenArrIndex++] = _selected.slice(_start, (_start += _num));
      }
      _fn();
      function _fn() {
        if (_result.length) {
          let _itemIndex = 0;
          let _itemLength = _result[_itemIndex].length;
          _result[_itemIndex].forEach(_child => {
              
              console.log(_child)
              
            APP.fnIdCardDecrypt(_child.extend.card_id, _child.idcard_sha1, res => {
              _child.extend.card_id = res;
              delete _child.selected;
              fnRequestPlatform(
                {
                  url: '/Rc/uploadPersonnel',
                  method: 'POST',
                  data: {
                    carry: JSON.stringify(_child)
                  }
                },
                res => {
                  ++_itemIndex;
                  _percentage += _tage;
                  _that.percentage = Number(APP.fnTwoFloat(_percentage)); // 加载进度条
                  if (res.code == 0) {
                    _uploadResult.push({
                      info: _child,
                      result: res.data
                    });
                  }
                  if (_itemIndex == _itemLength) {
                    _result.splice(0, 1);
                    _fn();
                  }
                }
              );
            });
          });
        } else {
          _that.percentage = 100;
          _that.progressText = '已完成';
          setTimeout(() => {
            _that.showProgress = false;
            _that.isUploadShow = false;
            if (_uploadResult.length) {
              _that.errorInfoRcList = _uploadResult;
              _that.showErrorInfoRc = true;
            } else {
              _that.fnCloseUploadRc();
              _that.$message.success('上传人员至融创成功');
            }
          }, 800);
        }
      }
    }
  }
};
</script>

<style scoped lang="scss" type="text/scss">
@import '~@/styles/mixin.scss';
.dialog_uploadRc,
.dialog_uploadError,
.dialog_isUpload {
  .btn_line {
    @include flex-box(center, center);
  }
  >>> .el-dialog__body {
    padding: 10px 20px;
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
}
.dialog_uploadRc {
  >>> .el-dialog {
    width: 1600px;
    height: 762px;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  .search_name {
    height: 32px;
    @include flex-box(flex-start, center);
    .line_input {
      min-width: 280px;
      height: 30px;
      margin-right: 10px;
      border-top-right-radius: 1px;
      border-bottom-right-radius: 1px;
      background-color: rgba(49, 88, 128, 0.4);
      @include flex-box(flex-start, center);
      .input_title {
        width: 69px;
        height: 30px;
        font-size: 14px;
        color: #9bf9fc;
        border-radius: 2px;
        background-color: rgba(155, 249, 252, 0.1);
        @include flex-box(center, center);
      }
      .input_box {
        width: 211px;
        height: 30px;
        line-height: 30px;
        padding-left: 15px;
        color: rgba(77, 180, 244, 0.7);
        font-size: 12px;
        border-radius: 2px;
        outline: none;
        background: transparent;
        border: none;
        &::-webkit-input-placeholder {
          color: rgba(77, 180, 244, 0.7);
        }
        &::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: rgba(77, 180, 244, 0.7);
        }
        &:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: rgba(77, 180, 244, 0.7);
        }
        &:-ms-input-placeholder {
          /* Internet Explorer 10-11 */
          color: rgba(77, 180, 244, 0.7);
        }
      }
    }
  }
  .line_item {
    margin: 5px;
    font-size: 16px;
    height: 20px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.8);
    &.center {
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
  }
  .cont_list {
    width: 1560px;
    height: 570px;
    color: #ffffff;
    font-size: 16px;
    border-radius: 10px;
    margin: 0;
    background-color: rgba(29, 68, 149, 0.1);
    .list_title {
      width: 1560px;
      height: 48px;
      background: url(../../assets/img/per_list_bg.png) no-repeat;
      background-size: 100% 100%;
      @include flex-box(flex-start, center);
      .title_item {
        height: 48px;
        @include flex-box(center, center);
        &:nth-child(1) {
          width: 56px;
          margin: 0 4px 0 30px;
        }
        &:nth-child(2) {
          width: 106px;
          margin-right: 4px;
        }
        &:nth-child(3) {
          width: 116px;
          margin-right: 4px;
        }
        &:nth-child(4) {
          width: 106px;
          margin-right: 4px;
        }
        &:nth-child(5) {
          width: 196px;
          margin-right: 4px;
        }
        &:nth-child(6) {
          width: 196px;
          margin-right: 4px;
        }
        &:nth-child(7) {
          width: 126px;
          margin-right: 4px;
        }
        &:nth-child(8) {
          width: 126px;
          margin-right: 4px;
        }
        &:nth-child(9) {
          width: 156px;
          margin-right: 4px;
        }
        &:nth-child(10) {
          width: 156px;
          margin-right: 4px;
        }
        &:nth-child(11) {
          width: 120px;
          margin-right: 30px;
        }
        .select {
          width: 20px;
          height: 20px;
          border: 1px solid #65a6dd;
          border-radius: 2px;
          cursor: pointer;
          @include prefixCss3(transition, border-color 0.2s);
          &:hover {
            border-color: #409eff;
          }
          &.active {
            background-color: #409eff;
            border-color: #409eff;
            &::after {
              content: '';
              display: block;
              width: 100%;
              height: 100%;
              @include set-bg-img('../../assets/images/icon-yes.png');
            }
          }
        }
      }
    }
    .list_boxes {
      width: 1500px;
      height: 522px;
      margin-left: 30px;
      position: relative;
      overflow: hidden;
      .list_box {
        position: absolute;
        left: 0;
        right: -25px;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
        .box_line {
          width: 1500px;
          height: 70px;
          margin: 5px 0 0 0px;
          border-bottom: 1px dashed #1d4495;
          @include flex-box(flex-start, center);
          .list_item {
            height: 70px;
            text-align: center;
            @include flex-box(center, center);
            &:nth-child(1) {
              width: 56px;
              margin-right: 4px;
            }
            &:nth-child(2) {
              width: 106px;
              margin-right: 4px;
            }
            &:nth-child(3) {
              width: 116px;
              margin-right: 4px;
            }
            &:nth-child(4) {
              width: 106px;
              margin-right: 4px;
            }
            &:nth-child(5) {
              width: 196px;
              margin-right: 4px;
            }
            &:nth-child(6) {
              width: 196px;
              margin-right: 4px;
            }
            &:nth-child(7) {
              width: 126px;
              margin-right: 4px;
            }
            &:nth-child(8) {
              width: 126px;
              margin-right: 4px;
            }
            &:nth-child(9) {
              width: 156px;
              margin-right: 4px;
            }
            &:nth-child(10) {
              width: 156px;
              margin-right: 4px;
            }
            &:nth-child(11) {
              width: 120px;
            }
            img {
              width: 60px;
              height: 60px;
              border-radius: 50%;
            }
            .input_box {
              width: 190px;
              height: 30px;
              line-height: 30px;
              padding-left: 15px;
              color: rgba(77, 180, 244, 0.7);
              background-color: rgba(49, 88, 128, 0.4);
              font-size: 12px;
              border-radius: 2px;
              outline: none;
              border: none;
              &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
              }
              &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
              }
              &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
              }
              &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
              }
            }
            .select {
              width: 20px;
              height: 20px;
              border: 1px solid #65a6dd;
              border-radius: 2px;
              cursor: pointer;
              @include prefixCss3(transition, border-color 0.2s);
              &:hover {
                border-color: #409eff;
              }
              &.active {
                background-color: #409eff;
                border-color: #409eff;
                &::after {
                  content: '';
                  display: block;
                  width: 100%;
                  height: 100%;
                  @include set-bg-img('../../assets/images/icon-yes.png');
                }
              }
            }
            span {
              width: 100%;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .select_box {
              width: 150px;
              height: 30px;
              border-radius: 2px;
              background-color: rgba(49, 88, 128, 0.4);
            }
            >>> .el-input__inner {
              width: 150px;
              height: 30px;
              border-radius: 2px;
              border: none;
              color: rgba(77, 180, 244, 0.7);
              background: transparent;
              &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
              }
              &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
              }
              &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
              }
              &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
              }
            }
            >>> .el-select__caret {
              color: rgba(77, 180, 244, 0.7);
            }
            >>> .el-select-dropdown {
              background-color: rgba(9, 17, 32, 1);
              border: 1px solid rgba(77, 180, 244, 1);
            }
            >>> .popper__arrow {
              border-bottom-color: rgba(77, 180, 244, 1) !important;
            }
            >>> .el-select-dropdown__item {
              color: rgba(77, 180, 244, 0.7);
            }
            >>> .el-select-dropdown__item:hover {
              color: #409eff;
            }
            >>> .el-select-dropdown__item.hover {
              color: #409eff;
            }
            >>> .el-input__icon {
              color: rgba(77, 180, 244, 0.7);
            }
            >>> .el-range-input {
              color: rgba(77, 180, 244, 0.7);
              background: transparent;
              &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
              }
              &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
              }
              &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
              }
              &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
              }
            }
          }
        }
      }
    }
  }
}
.dialog_uploadError {
  >>> .el-dialog {
    width: 900px;
    height: 600px;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  .cont_list {
    width: 840px;
    height: 425px;
    color: #ffffff;
    font-size: 16px;
    border-radius: 10px;
    margin: 0;
    background-color: rgba(29, 68, 149, 0.1);
    .list_title {
      width: 840px;
      height: 48px;
      background: url(../../assets/img/per_list_bg.png) no-repeat;
      background-size: 100% 100%;
      @include flex-box(flex-start, center);
      .title_item {
        height: 48px;
        @include flex-box(center, center);
        &:nth-child(1) {
          width: 158px;
          margin-right: 2px;
          margin-left: 30px;
        }
        &:nth-child(2) {
          width: 156px;
          margin: 0 2px;
        }
        &:nth-child(3) {
          width: 458px;
          margin-left: 2px;
          margin-right: 30px;
        }
      }
    }
    .list_boxes {
      width: 780px;
      height: 377px;
      margin-left: 30px;
      position: relative;
      overflow: hidden;
      .list_box {
        position: absolute;
        left: 0;
        right: -25px;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
        .box_line {
          width: 780px;
          height: 70px;
          margin: 5px 0 0 0px;
          border-bottom: 1px dashed #1d4495;
          @include flex-box(flex-start, center);
          &:hover {
            background-color: rgba(49, 88, 128, 0.4);
          }
          .list_item {
            height: 70px;
            text-align: center;
            @include flex-box(center, center);
            &:nth-child(1) {
              width: 160px;
              margin-right: 2px;
            }
            &:nth-child(2) {
              width: 156px;
              margin-right: 2px;
            }
            &:nth-child(3) {
              width: 454px;
            }
            img {
              width: 60px;
              height: 60px;
              border-radius: 50%;
            }
            span {
              width: 100%;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
.progress {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  .progress-box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50%;
    text-align: center;
    @include prefixCss3(transform, translate(-50%, -50%));
    span {
      line-height: 30px;
      color: rgba(58, 116, 221, 1);
      font-size: 16px;
    }
  }
}
.dialog_isUpload {
  >>> .el-dialog {
    width: 500px;
    height: 180px;
    margin-top: 40vh !important;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-dialog__body {
    padding: 20px;
  }
  div {
    width: 100%;
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Person/uploadRC.vue